import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { CloseOutlined, UndoOutlined, DeleteOutlined } from '@ant-design/icons';
import httpInjectorService from 'services/http-injector.service';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const VersionPanel = ({ onClose, GetBoardContent, onPreview ,itemType,typeid }) => {
  const { spaceid } = useParams();
  const [versions, setVersions] = useState([]);
  const [selectedVersionId, setSelectedVersionId] = useState(null);

 

  const getVersionHistory = async () => {
    try {
      const response = await httpInjectorService.getVersionHistory(
        spaceid,
        typeid,
       itemType,
      );

      if (response.status === 'success') {
        setVersions(response.data || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getVersionHistory();
  }, []);

  const handleRestore = async (versionId, versionNumber) => {
    try {
      const payload = {
        space_id: Number(spaceid),
        item_id: Number(typeid),
        version_number: versionNumber,
        version_id: versionId,
      };
      const response = await httpInjectorService.restorePageVersion(payload);
      if (response.status === 'success') {
        getVersionHistory();
        GetBoardContent();
        toast.success(response.message || 'Version restored succesfully', {
          autoClose: 1000,
          position: 'top-right',
        });
      }
    } catch (error) {
      toast.error(error.message || 'Something went wrong', {
        autoClose: 1000,
        position: 'top-right',
      });
    }
  };

  const handleDelete = async (versionId) => {
    try {
      const response = await httpInjectorService.deleteVersion(
        Number(spaceid),
        Number(typeid),
        versionId,
      );
      if (response.status === 'success') {
        getVersionHistory();
        toast.success(response.message || 'Version deleted succesfully', {
          autoClose: 1000,
          position: 'top-right',
        });
      }
    } catch (error) {
      toast.error(error.message || 'Something went wrong', {
        autoClose: 1000,
        position: 'top-right',
      });
    }
  };


  const currentVersion = versions.find((v) => v.is_current === 1);
  const otherVersions = versions.filter((v) => v.is_current !== 1);

  const formatDate = (date) => {
    return new Date(date).toLocaleString();
  };

  const renderVersionItem = (v, isCurrent = false) => (
    <div
      key={v.version_id}
      onClick={() => {
        if (!isCurrent) {
          setSelectedVersionId(v.version_id);
          onPreview(v.version_id);
        }
      }}
      style={{
        padding: '10px 12px',
        borderRadius: 8,
        marginBottom: 8,
        background: isCurrent ? '#eef2ff' : '#fff',
        border:
          selectedVersionId === v.version_id
            ? '2px solid #6366f1'
            : isCurrent
              ? '1px solid #6366f1'
              : '1px solid #e5e7eb',
        cursor: isCurrent ? 'default' : 'pointer',
        position: 'relative',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 6,
          right: 6,
          display: 'flex',
          gap: 6,
          opacity: 0.7,
        }}
      >
        {!isCurrent && (
          <>
            <UndoOutlined
              title="Restore"
              onClick={(e) => {
                e.stopPropagation();
                handleRestore(v.version_id, v.version_number);
              }}
              style={{
                fontSize: 14,
                padding: 4,
                borderRadius: 6,
                background: '#e0f2fe',
                color: '#0284c7',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = '#bae6fd')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = '#e0f2fe')
              }
            />

            <DeleteOutlined
              title="Delete"
              onClick={(e) => {
                e.stopPropagation();
                handleDelete(v.version_id);
              }}
              style={{
                fontSize: 14,
                padding: 4,
                borderRadius: 6,
                background: '#fee2e2',
                color: '#ef4444',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = '#fecaca')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = '#fee2e2')
              }
            />
          </>
        )}
      </div>

      <div style={{ fontWeight: 600, fontSize: 13 }}>
        v{v.version_number}
        {isCurrent && (
          <span
            style={{
              marginLeft: 8,
              fontSize: 10,
              background: '#6366f1',
              color: '#fff',
              padding: '2px 6px',
              borderRadius: 10,
            }}
          >
            CURRENT
          </span>
        )}
      </div>

      <div style={{ fontSize: 11, color: '#64748b', marginTop: 4 }}>
        {formatDate(v.created_at)}
      </div>

      <div style={{ fontSize: 11, color: '#94a3b8' }}>{v.author}</div>
    </div>
  );

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 12,
          borderBottom: '1px solid #eee',
          paddingBottom: 10,
        }}
      >
        <h4 style={{ margin: 0 }}>Version History</h4>
        <Button type="text" icon={<CloseOutlined />} onClick={onClose} />
      </div>

      <div style={{ overflowY: 'auto', flex: 1 }}>
        {currentVersion && (
          <>
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: '#64748b',
                marginBottom: 8,
              }}
            >
              CURRENT VERSION
            </div>
            {renderVersionItem(currentVersion, true)}
          </>
        )}

        {otherVersions.length > 0 && (
          <>
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: '#64748b',
                margin: '16px 0 8px',
              }}
            >
              AUTOSAVED VERSIONS
            </div>

            {otherVersions.map((v) => renderVersionItem(v))}
          </>
        )}
      </div>
    </div>
  );
};

export default VersionPanel;
